// Module
var code = "<div class=\"icon-container\"> <tooltip class=\"help-icon\" tooltips tooltip-side=\"{{ vm.direction }}\" tooltip-template=\"{{ vm.text }}\" tooltip-size=\"{{ vm.size }}\" tooltip-class=\"help-tooltip\"><i class=\"material-icons\">help</i></tooltip> </div> ";
// Exports
module.exports = code;